import {memo, useMemo} from 'react';
import {forbidExtraProps} from 'airbnb-prop-types';
import {any} from 'prop-types';
import {shuffle} from 'lodash';
import ProfileProvider from './ProfileProvider';
import Layer2 from './Layer2';


export default memo(Layer3);

Layer3.propTypes = forbidExtraProps({
  children: any.isRequired,
});

function Layer3({
  children,
}) {
  return useMemo(
    () => shuffle([
      ProfileProvider,
    ]).reduce(
      (acc, Provider) => (
        <Provider>
          {acc}
        </Provider>
      ),
      (
        <Layer2>
          {children}
        </Layer2>
      ),
    ),
    [],
  );
}
